const formatPrice = (value: number, showDecimal = true): string => {
    const absVal = Math.abs(value).toLocaleString('en-US', {
        minimumFractionDigits: showDecimal ? 2 : 0,
        maximumFractionDigits: showDecimal ? 2 : 0
    });
    return `${value < 0 ? '-' : ''}$${absVal}`;
};

export default formatPrice;